import { AxiosError, AxiosResponse } from "axios";
import { RequestResponse } from "../types";
import { NotifyCenter } from "project-config/services/notify-center";

const whitelistUrlPatterns = ["/api/rendering/user/queryUser"];

export default async function errorInterceptors(
  error: AxiosError<RequestResponse<any>>
) {
  const response = error.response;
  console.log("response::::", response);
  const isWhitelisted = response?.config?.url
    ? whitelistUrlPatterns.some((pattern) =>
        response?.config?.url?.includes(pattern)
      )
    : false;
  if (isWhitelisted) {
    // 白名单接口，继续抛出错误
    console.warn(
      `Whitelisted API error (${response?.status}), will trigger ErrorBoundary:`,
      response?.config?.url
    );
    return Promise.reject(error);
  } else {
    NotifyCenter.axiosResponseInterceptor.emit(
      error.response as AxiosResponse<RequestResponse<any>>
    );
    // 非白名单接口，消化错误
    return response;
  }
}
